<template>
    <div>
        <el-dialog
            :visible.sync="show_print"
            :append-to-body="true"
            width="60%"
            :center="true"
            top="10vh"
            :close-on-click-modal="false"
            :before-close="() => $emit('exit_print')"
        >
            <div ref="PrintPetty">
                <p style="text-align: center;">
                    <b>
                        <span style="font-size:18px;">{{data | title_name}}</span>
                    </b>
                </p>
                <table style="font-family: Microsoft YaHei;font-size:15px;width: 100%;border: 1px solid black;">
                    <tr style="border: 1px solid black;">
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">申请部门</td>
                        <td style="width: 45%;border: 1px solid black;text-align: center;">{{data.enterprise_name+'/'+data.department_name}}</td>
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">申请人</td>
                        <td style="width: 25%;border: 1px solid black;text-align: center;">{{data.staff_name}}</td>
                    </tr>
                    <tr style="border: 1px solid black;">
                        <td style="border: 1px solid black;text-align: center;font-weight:bold;">借支标题</td>
                        <td style="border: 1px solid black;text-align: center;" colspan=3>{{data.title}}</td>
                    </tr>
                    <tr style="border: 1px solid black;">
                        <td style="border: 1px solid black;text-align: center;font-weight:bold;">申请原由</td>
                        <td style="border: 1px solid black;text-align: left;white-space: pre-line;" colspan=3>{{data.content}}</td>
                    </tr>
                    <tr style="border: 1px solid black;">
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">申请类型</td>
                        <td style="width: 45%;border: 1px solid black;text-align: center;">{{all_type[data.type]}}</td>
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">申请金额</td>
                        <td style="width: 25%;border: 1px solid black;text-align: center;">{{data.money | diy_money}}</td>
                    </tr>
                    <tr style="border: 1px solid black;">
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">已用金额</td>
                        <td style="width: 45%;border: 1px solid black;text-align: center;">{{data.use_money | diy_money}}</td>
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">剩余金额</td>
                        <td style="width: 25%;border: 1px solid black;text-align: center;">{{(data.money-data.use_money) | diy_money}}</td>
                    </tr>
                    <tr style="border: 1px solid black;">
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">汇款方式</td>
                        <td style="width: 45%;border: 1px solid black;text-align: center;">{{all_pay_way[data.pay_way]}}</td>
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">收款人</td>
                        <td style="width: 25%;border: 1px solid black;text-align: center;">{{data.account_name}}</td>
                    </tr>
                    <tr style="border: 1px solid black;">
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">开户行</td>
                        <td style="width: 45%;border: 1px solid black;text-align: center;">{{data.account_bank}}</td>
                        <td style="width: 15%;border: 1px solid black;text-align: center;font-weight:bold;">银行卡号</td>
                        <td style="width: 25%;border: 1px solid black;text-align: center;">{{data.account_card}}</td>
                    </tr>
                    <tr style="border: 1px solid black;">
                        <td style="border: 1px solid black;text-align: center;font-weight:bold;">审批人</td>
                        <td style="border: 1px solid black;text-align: center;" colspan=3>{{examine}}</td>
                    </tr>
                </table>
                <div v-for="(iteam,index) in data.print" :key="iteam.time" style="font-family: Microsoft YaHei;font-size:15px;">
                    {{'【历史】此备用金申请为第'+(index+1)+'次打印，打印人：'+iteam.staff+'，打印时间：'+iteam.time}}
                </div>
                <div style="font-family: Microsoft YaHei;font-size:15px;">
                    {{'【当前】此备用金申请为第'+(data.print.length+1)+'次打印，打印人：'+$store.state.user.name+'，打印时间：' + NowTime}}
                </div>
                <br/>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    plain
                    type="primary"
                    @click="printBtn('PrintPetty')"
                    >打印</el-button
                >
                <el-button
                    plain
                    @click="() => $emit('exit_print')"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { fomatFloat,thousandBitSeparator,now } from '@/assets/js/common.js'
import { petty_print_request } from '@/network/finance/petty.js'

export default {
    name:'PettyPrintComponent',
    data(){
        return {
            examine: '',
            NowTime: '',
            all_pay_way: ['公对公','公对私','私对私','私对公'],
            all_type: ['提前借支','储备额度','保证金']
        }
    },
    computed:{},
    methods:{
        printBtn(formRef) {
            this.login_loading = true
            petty_print_request(this.data.id)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$print(this.$refs[formRef])
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
    },
    filters:{
        diy_money(v) {
            return '￥'+ thousandBitSeparator(fomatFloat(v))
        },
        title_name(v) {
            let a = '备用金：'+v.name+' '

            if(v.state === 0) {
                a += '【待提交】'
            } else if(v.state === 1) {
                a += '【审批中】'
            } else if(v.state === 2) {
                a += '【已通过】'
            } else if(v.state === 3) {
                a += '【已拒绝】'
            }

            if(v.pay_state === 0) {
                a += '【未汇款】'
            } else if(v.pay_state === 1) {
                a += '【已汇款】'
            }

            return a
        }
    },
    props:{
        show_print: {
            type: Boolean,
            default() {
                return false
            }
        },
        data: {
            type: Object,
            default() {
                return {}
            }
        },
        ApprovalData: {
            type: Array,
            default() {
                return []
            }
        }
    },
    created(){},
    destoryed(){},
    mounted(){},
    updated(){
        this.NowTime = now()
    },
    components:{},
    watch:{
        ApprovalData(newVal) {
            this.examine = ''
            newVal.forEach(v => {
                if(v.start_staff_id) {
                    this.examine = v.start_staff_name+'(发起)'
                }
                if(v.staff_id === -1) {
                    this.examine += '→'+v.staff_name+'(撤回)'
                }
                if((v.staff_id>0) && (!v.time)) {
                    this.examine += '→'+v.staff_name+'(待审批)'
                }
                if(v.opinion) {
                    this.examine += '→'+v.staff_name+'('+v.opinion+')'
                }
                if(v.staff_id === 0) {
                    this.examine += '→流程结束'
                }
            });
        }
    }
}
</script>

<style>
</style>